import MembershipRepository from '@/js/api/MembershipRepository'

//Public organization data that user currently viewing
const getDefaultState = () => {
  return {
    organization: null,
    classes: null,
    currentClass: null,
    membershipTemplates: null
  }
}

// In-flight request dedup for the public membership templates. Kept out of state (it's a promise,
// not data to render) and cleared whenever the org context resets.
let membershipTemplatesRequest = null

export default {
  namespaced: true,
  state: getDefaultState(),

  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
      membershipTemplatesRequest = null
    },
    setOrganization (state, organization) {
      if (!organization){
        state.organization = null

      } else {
        /*let basicOrganizationData = {
          id: organization.id,
          name: organization.name,
          identifier: organization.identifier,
          description: organization.description
        }

        state.organization = basicOrganizationData*/
        state.organization = organization
      }
    },
    setClasses(state, classes) {
      state.classes = classes
    },
    setCurrentClass(state, myClass) {
      state.currentClass = myClass
    },
    setMembershipTemplates(state, templates) {
      state.membershipTemplates = templates
    }
  },

  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },

    setOrganization({ commit }, organization) {
      commit('setOrganization', organization)
    },
    setClasses({ commit }, classes) {
      commit('setClasses', classes)
    },
    setCurrentClass({ commit }, myClass) {
      commit('setCurrentClass', myClass)
    },
    /**
     * Load the current org's public membership templates into the store, fetching once and reusing
     * the result for every public surface that needs it (class-page "memberships from X" hint, the
     * memberships page). Concurrent callers share one in-flight request. Pass `force: true` to
     * refetch fresh (used by the memberships page so it always shows current data). Resolves to the
     * templates array.
     */
    loadMembershipTemplates ({ state, commit }, { force = false } = {}) {
      const orgId = state.organization?.id
      if (!orgId) {
        return Promise.resolve(state.membershipTemplates || [])
      }
      if (!force && Array.isArray(state.membershipTemplates)) {
        return Promise.resolve(state.membershipTemplates)
      }
      if (!force && membershipTemplatesRequest) {
        return membershipTemplatesRequest
      }
      membershipTemplatesRequest = MembershipRepository.getPublicMembershipTemplates(orgId)
        .then(list => {
          commit('setMembershipTemplates', list || [])
          membershipTemplatesRequest = null
          return state.membershipTemplates
        })
        .catch(error => {
          // Don't keep a failed request around — let the next caller retry.
          membershipTemplatesRequest = null
          throw error
        })
      return membershipTemplatesRequest
    }
  },
  getters: {
    organization: state => state.organization,
    classes: state => state.classes,
    currentClass: state => state.currentClass,
    membershipTemplates: state => state.membershipTemplates
  }
}
